import React from 'react';
import clsx from 'clsx';
import './style.scss';
import Button from '../../Shared/components/controls/Button';

const ThreeButtons = (props) => {
  const { primaryButton, secondaryButton, tertiaryButton, theme } = props;

  const shouldRenderPrimaryButton = !!primaryButton?.value?.href;
  const shouldRenderSecondaryButton = !!secondaryButton?.value?.href;
  const shouldRenderTertiaryButton = !!tertiaryButton?.value?.href;

  const shouldRenderAnyButton =
    shouldRenderPrimaryButton || shouldRenderSecondaryButton || shouldRenderTertiaryButton;
  if (!shouldRenderAnyButton) {
    return null;
  }

  return (
    <div className={clsx('wrap-buttons-generic flex-it flex-wrap', theme)}>
      {shouldRenderPrimaryButton && (
        <Button link={primaryButton} variant="contained" color="primary" />
      )}
      {shouldRenderSecondaryButton && (
        <Button link={secondaryButton} variant="outlined" color="primary" />
      )}
      {shouldRenderTertiaryButton && (
        <Button link={tertiaryButton} variant="text" color="primary" arrow="right" />
      )}
    </div>
  );
};

export default ThreeButtons;
